import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "fill", "label"]

  update() {
    const value = this.inputTarget.value
    this.fillTarget.style.width = `${value}%`
    this.labelTarget.textContent = `${value}%`

    // Update color
    const color = value < 30 ? "bg-error" : value < 70 ? "bg-warning" : "bg-success"
    this.fillTarget.className = this.fillTarget.className.replace(/bg-(error|warning|success)/, color)

    const labelColor = value < 30 ? "text-error" : value < 70 ? "text-warning" : "text-success"
    this.labelTarget.className = this.labelTarget.className.replace(/text-(error|warning|success)/, labelColor)
    if (!this.labelTarget.className.match(/text-(error|warning|success)/)) {
      this.labelTarget.classList.add(labelColor)
    }
  }
}
